function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/no-string-refs */
import React from 'react';
import ReactSelect from 'react-select';
import TetherComponent from 'react-tether/lib/react-tether';

var TetherSelect =
/*#__PURE__*/
function (_ReactSelect) {
  _inherits(TetherSelect, _ReactSelect);

  function TetherSelect(props) {
    var _this;

    _classCallCheck(this, TetherSelect);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TetherSelect).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "renderElement", function (menu, selectWidth) {
      return function () {
        return React.cloneElement(menu, {
          style: {
            position: 'static',
            width: selectWidth
          }
        });
      };
    });

    _this.renderOuter = _this._renderOuter;
    return _this;
  }

  _createClass(TetherSelect, [{
    key: "_renderOuter",
    value: function _renderOuter() {
      for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      var menu = _get(_getPrototypeOf(TetherSelect.prototype), "renderOuter", this).apply(this, params);

      var tetherProps = this.props.tetherProps; // Don't return an updated menu render if we don't have one

      if (!menu) return; // this.wrapper comes from the ref of the main Select component (super.render())

      var selectWidth = this.wrapper ? this.wrapper.offsetWidth : null;
      /* Apply position:static to our menu so that it's parent will get the correct dimensions
      and we can tether the parent */

      return React.createElement(TetherComponent, _extends({
        renderElementTo: "body",
        ref: "tethered-component",
        attachment: "top left",
        targetAttachment: "top left",
        constraints: [{
          to: 'window',
          attachment: 'together',
          pin: ['top']
        }]
      }, tetherProps, {
        renderElement: this.renderElement(menu, selectWidth)
      }));
    }
  }]);

  return TetherSelect;
}(ReactSelect);

TetherSelect.displayName = 'TetherSelect';
export default TetherSelect;